<template>
    <b-modal class="modal" size="xl" :id="modalId" ref="invite-letter-modal" :title="inviteLettersModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @hide="resetModal('main')">
      <template slot="modal-header" slot-scope="{ close }">
        <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'envelope-open-text']" size="1x" class="mr-2"/> {{ inviteLettersModal.modalData.title }}</h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
      </template>
      <template slot="default" v-if="inviteLettersModal.docuData && inviteLettersModal.docuData.documentId">
        <div class="col-lg-12 py-1">
          <span class="pretext-span tips-font-size">{{ t('inviteLettersModalInfoText', 'inviteLettersModalInfoText') }}</span>
        </div>
        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('batchNumberLabelText', 'batchNumberLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="batch_id" v-model="documentBatch" disabled></b-form-input>
          </b-input-group>
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('includeHiddenLabelText', 'includeHiddenLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-select v-model="formData.includeHidden" >
              <b-form-select-option :value="0">{{t('notHiddenOptionText', 'notHiddenOptionText')}}</b-form-select-option>
              <b-form-select-option :value="1">{{t('hiddenOptionText', 'hiddenOptionText')}}</b-form-select-option>
              <b-form-select-option :value="2">{{t('bothHiddenOptionText', 'bothHiddenOptionText')}}</b-form-select-option>
            </b-form-select>
          </b-input-group>
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('byEmailLabelText', 'byEmailLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-select v-model="formData.byEmail">
              <b-form-select-option :value="0">{{t('byEmailOptionText', 'byEmailOptionText')}}</b-form-select-option>
              <b-form-select-option :value="1">{{t('notByEmailOptionText', 'notByEmailOptionText')}}</b-form-select-option>
              <b-form-select-option :value="2">{{t('bothByEmailOptionText', 'bothByEmailOptionText')}}</b-form-select-option>
            </b-form-select>
          </b-input-group>
          <div class="col-lg-12 py-1">
            <span class="pretext-span tips-font-size">{{ t('duplicatesLabelInfoText', 'duplicatesLabelInfoText') }}</span>
          </div>
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('duplicatesLabelText', 'duplicatesLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-select v-model="formData.duplicates">
              <b-form-select-option :value="0">{{t('notDuplicatesOptionText', 'notDuplicatesOptionText')}}</b-form-select-option>
              <b-form-select-option :value="1">{{t('duplicatesOptionText', 'duplicatesOptionText')}}</b-form-select-option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </template>
      <template v-else>
        <p class="text-danger text-center">{{t('emptyDocumentBatchId','emptyDocumentBatchId')}}</p>
      </template>
      <template slot="modal-footer" slot-scope="{ close }">
        <button type="button" class="btn btn-secondary" @click="close()">{{t('cancelButtonText', 'cancelButtonText')}}</button>
        <button v-if="inviteLettersModal.docuData && inviteLettersModal.docuData.documentId" type="button" class="btn btn-primary" @click="prepareInviteLetter">{{t('oKButtonText', 'oKButtonText')}}</button>
      </template>
    </b-modal>
</template>

<script>
import { backendUrl } from '@/helpers/backendUrl.js'

export default {
  name: 'ModalInviteLetters',
  data() {
    return {
      modalId: 'inviteLettersModal',
      inviteLettersModal: {},
      formData: {
        includeHidden: 0,
        byEmail: 1,
        duplicates: 0,
      },
    }
  },
  computed:{
    documents: {
      get() {
        return this.$store.getters['documentsStore/getDocuments']
      }
    },
    documentBatch: {
      get() {
        let document = this.documents.data.find(
            ({ id }) => id === this.inviteLettersModal.docuData.documentId
        )
          return document.batch
      }
    }
  },
  methods: {
    resetModal(level, dataUrl, button = '') {
      this.$root.$emit('bv::hide::modal', this.modalId)
      this.$emit('hide', level, dataUrl, button)
      this.clear();
    },
    prepareInviteLetter() {
      this.$store.dispatch('alertClearResponse')
      this.$store.dispatch('downloadDataStore/prepareMergedInviteLetters', {
        documentBatch: this.documentBatch,
        includeHidden: this.formData.includeHidden,
        byEmail: this.formData.byEmail,
        duplicates: this.formData.duplicates,
      }).then(response => {
            if (response.status == 'success' && response.fileUrl) {
              let dataUrl = backendUrl() + '/downloadMergedInviteLetters/' + response.fileUrl
              this.resetModal('main', dataUrl)
            } else {
              this.resetModal('main')
            }
      })
    },
    clear() {
      this.formData = {
        includeHidden: 0,
        byEmail: 1,
        duplicates: 0,
      }
    }
  },
  created() {
    this.inviteLettersModal = this.$attrs.modal
  }
}
</script>

<style scoped>

</style>